import Guard from 'arg-guard'

/**
 * A renovation partnered with an operation status.
 *
 * @export RenovationOperationResult
 * @class RenovationOperationResult
 */
export default class RenovationOperationResult {

    /**
     * Creates an instance of a RenovationOperationResult.
     * @param {Renovation} data Source renovation object.
     * @param {boolean} success Indicates the success of the operation.
     * @param {?string} message Information about the operation. If not provided will reflect success.
     * @memberof RenovationOperationResult
     */
    constructor(data = null, success = true, message = null) {
        this.data = data
        this.success = data && success
        this.message = message || success ? 'Succeeded' : 'Failed'
    }

    /**
     * Generates a successful result.
     * @param {Renovation} data The source data for the response.
     * @returns {RenovationOperationResult}
     */
    static succeeded(data) {
        Guard.throwIfNull(data, 'data')
        return new RenovationOperationResult(data)
    }

    /**
     * Returns a failed result.
     * @param {?string} message An optional message.
     * @returns {RenovationOperationResult}
     */
    static failed(message) {
        return new RenovationOperationResult(null, false, message)
    }

    /**
     * Returns an ignored result.
     * @param {string} message Information about why the operation was ignored.
     * @returns {RenovationOperationResult}
     */
    static ignored(message) {
        return new RenovationOperationResult(null, true, message)
    }
}
